import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFirebaseAuth } from './firebase';

export class SignInPopupClosedError extends Error {
  constructor() {
    super('Popup closed before sign-in completed');
    this.name = 'SignInPopupClosedError';
  }
}

export const signInWithGoogle = async (): Promise<void> => {
  const auth = getFirebaseAuth();
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    // Force-mint a fresh token so the first authenticated fetch is up-to-date.
    await result.user.getIdToken(true);
  } catch (e) {
    const code = (e as { code?: string } | null)?.code ?? '';
    if (code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request') {
      throw new SignInPopupClosedError();
    }
    throw e;
  }
};

export const signOutOfFirebase = async (): Promise<void> => {
  await signOut(getFirebaseAuth());
};
